import React from 'react';
type GlowPosition = 'top-right' | 'top-left' | 'bottom-left' | 'bottom-right' | 'center' | 'none';
interface DarkGreenTextureProps {
  /** Where (and whether) to render the subtle lime glow. Vary this per
   *  section so each dark-green surface feels a little different. */
  glow?: GlowPosition;
  /** Optional extra classes on the grid layer (e.g. opacity tweaks). */
  className?: string;
}
const GLOWS: Record<Exclude<GlowPosition, 'none'>, string> = {
  'top-right': 'pointer-events-none absolute -top-40 -right-40 w-[640px] h-[640px] rounded-full bg-[#F97316]/[0.10] blur-[150px]',
  'top-left': 'pointer-events-none absolute -top-32 -left-32 w-[520px] h-[520px] rounded-full bg-[#F97316]/[0.10] blur-[140px]',
  'bottom-left': 'pointer-events-none absolute -bottom-44 -left-32 w-[560px] h-[560px] rounded-full bg-[#EA580C]/[0.14] blur-[150px]',
  'bottom-right': 'pointer-events-none absolute -bottom-40 -right-28 w-[520px] h-[520px] rounded-full bg-[#F97316]/[0.10] blur-[150px]',
  center: 'pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[720px] h-[720px] rounded-full bg-[#F97316]/[0.18] blur-[150px]'
};
/**
 * Shared decorative texture for the brand's dark-green (#2B211A) surfaces:
 * a subtle line grid plus an optional, positionable lime glow. The parent
 * must be `relative overflow-hidden`, and foreground content should sit at
 * `z-10` (or higher) so it renders above this overlay.
 */
export function DarkGreenTexture({
  glow = 'top-right',
  className = ''
}: DarkGreenTextureProps) {
  return <>
      <div aria-hidden="true" className={`dot-matrix-dark ${className}`} data-id="element-2901" data-mp="22kqs6vz4z9dw" />
      {glow !== 'none' && <div aria-hidden="true" className={GLOWS[glow]} data-id="element-2902" data-mp="27fmt6lmcp735" />}
    </>;
}